module.exports = {"actions":{"edit":"Bewerken","delete":"Verwijderen","save":"Opslaan","cancel":"Annuleren","back":"Terug","print":"Afdrukken"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/general.json
// module id = RYyu
// module chunks = 9